import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import PrimaryButton from '~/src/components/common/forms/Button/PrimaryButton';
import { Colors } from '~/src/scss/common/style';
import OrdersApi from '~/src/services/api/OrdersApi';
import { ExternalOrdersQuantityResponseDto } from '~/src/types/ExternalOrdersQuantityResponseDto';

const ExternalOwnerConsolidations = (): JSX.Element => {
  const history = useHistory();
  const [quantities, setQuantities] = useState<ExternalOrdersQuantityResponseDto | null>(null);

  useEffect(() => {
    const fetchQuantities = async () => {
      try {
        const response = await OrdersApi.getExternalOrdersQuantity();
        setQuantities(response.data);
      } catch (error) {
        console.error('Failed to fetch external orders quantity', error);
      }
    };

    fetchQuantities();
  }, []);

  return (
    <Wrapper>
      <Title>External Owner Consolidations</Title>
      {quantities ? (
        <>
          <p>
            There are <b>{quantities.ordersToBeConsolidated} orders</b> to be consolidated.
          </p>
          <p>
            There are <b>{quantities.ordersInConsolidation} orders</b> in consolidations.
          </p>
        </>
      ) : (
        <p>Loading...</p>
      )}
      <PrimaryButton title="View" onClick={() => history.push('/external-orders-list')} />
    </Wrapper>
  );
};

const Title = styled.h1`
  color: ${Colors.darkBrown};
  padding: 0;
  font-size: 20px;
`;

const Wrapper = styled.div`
  padding: 45px 60px;
  background-color: #f4f4f4;
  border-radius: 10px;
  width: 650;
  height: min-content;
`;

export default ExternalOwnerConsolidations;